import React from "react";

interface ArrowLeftProps {
  color?: string;
}
export default function ArrowLeft(props: ArrowLeftProps) {
  const { color } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 15.809 27.117">
      <g id="Icons_Arrows_Left" data-name="Icons / Arrows / Left" transform="translate(0.75 1.059)">
        <path
          id="Path"
          d="M14,25,0,12.5,14,0"
          fill="none"
          stroke={color || "#000"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="4.5"
        />
      </g>
    </svg>
  );
}
